export default "__VITE_ASSET__63b158db__"